export const sequence = (to: number): number[] => Array.from({ length: to }, (_, i) => i);

export const copy = <T>(amount: number, getElem: (i: number) => T): T[] =>
    sequence(amount).map((_, i) => getElem(i));

interface ArrayElement {
  id: number | string;
  [key: string]: any;
}

export const compareArray = <T extends ArrayElement>(state: T[], array: T[]): T[] => {
  let temp: T[] = [];
  let newState: T[] = [...state];
  array.forEach((el) => {
    let y = state.find((elem) => el.id === elem.id);
    temp.push(el);
    if (y) {
      newState = newState.filter((elem) => y?.id !== elem.id);
    }
  });
  return [...temp, ...newState];
};
